module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"LogoutButton":{"text":"Odhlásit"}},"de":{"LogoutButton":{"text":"Abmelden"}},"sk":{"LogoutButton":{"text":"Odhlásiť"}}}')
  delete Component.options._Ctor
}
